import styled, { css } from 'styled-components';
import HvSvg from 'src/components/HvSvg';
import constants from 'src/constants';

const { DEVICE } = constants.breakpoint;

const HEADER_HEIGHT = 90;

export const MeasureCategoryContainer = styled.div`
  position: absolute;
  width: 100%;
  height: calc(100% - (${HEADER_HEIGHT}px));
  top: 90px;
  overflow: auto;
`;

export const MeasureSidebarContainer = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;

  img {
    width: 50px;
    height: 50px;
  }
`;

export const CategoryContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: ${({ theme }) => theme.utils.pxToRem(60)}rem;
  background-color: ${({ theme, selected }) => {
    return selected
      ? theme.colors.viewer.sidebar.hoverItemBackground
      : theme.colors.white;
  }};
  border-bottom-width: ${({ theme }) => theme.utils.pxToRem(1)}rem;
  border-bottom-style: solid;
  border-bottom-color: ${({ theme }) =>
    theme.colors.viewer.sidebar.categoryBorder};
  padding-left: ${({ theme }) => theme.utils.pxToRem(18)}rem;
  padding-right: ${({ theme }) => theme.utils.pxToRem(13)}rem;
  cursor: pointer;
  :hover {
    background-color: ${({ theme }) =>
      theme.colors.viewer.sidebar.hoverItemBackground};
  }
  ${({ theme, selected }) =>
    selected &&
    css`
      ${CountBox} {
        background-color: ${theme.colors.viewer.sidebar.selectedDarkBackground};
      }
    `}

  @media ${DEVICE.MOBILE_LANDSCAPE} {
    /* for notch on iphone */
    padding-left: env(safe-area-inset-left);
  }
`;

export const CountBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: start;
  padding: 0 ${({ theme }) => theme.utils.pxToRem(4)}rem;
  width: ${({ theme }) => theme.utils.pxToRem(38)}rem;
  height: ${({ theme }) => theme.utils.pxToRem(22)}rem;
  margin-top: ${({ theme }) => theme.utils.pxToRem(11)}rem;
  border-radius: ${({ theme }) => theme.utils.pxToRem(3)}rem;
  background-color: ${({ theme }) => theme.colors.viewer.sidebar.countBox};
`;

export const CountText = styled.span`
  ${({ theme }) => theme.mixins.font('medium', 12)}
  color: ${({ theme }) => theme.colors.white};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const HeaderAndTotal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: ${({ theme }) => theme.utils.pxToRem(200)}rem;
  height: ${({ theme }) => theme.utils.pxToRem(42)}rem;
  margin-left: ${({ theme }) => theme.utils.pxToRem(12)}rem;
`;

export const Header = styled.div`
  ${({ theme }) => theme.mixins.font('bold', 16)}
  line-height: 1.25;
  letter-spacing: ${({ theme }) => theme.utils.pxToRem(-0.2)}rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.colors.viewer.sidebar.headerText};
  ${CategoryContainer}:hover & {
    color: ${({ theme }) => theme.colors.defaultActionBlue};
  }
`;

export const Total = styled.div`
  width: ${({ theme }) => theme.utils.pxToRem(215)}rem;
  height: ${({ theme }) => theme.utils.pxToRem(14)}rem;
  ${({ theme }) => theme.mixins.font('book', 12)}
  line-height: 1.17;
  color: ${({ theme }) => theme.colors.viewer.sidebar.gray};
`;

export const RightArrow = styled(HvSvg)`
  display: inline-block;
  align-self: start;
  margin-top: ${({ theme }) => theme.utils.pxToRem(17)}rem;
  svg path {
    ${CategoryContainer}:hover & {
      fill: ${({ theme }) => theme.colors.defaultActionBlue};
    }
  }

  @media ${DEVICE.MOBILE_PORTRAIT} {
    position: absolute;
    right: 15px;
  }
`;

export const JobType = styled.div`
  display: flex;
  align-items: center;
  width: ${({ theme }) => theme.utils.pxToRem(181)}rem;
  height: ${({ theme }) => theme.utils.pxToRem(30)}rem;
  margin-top: ${({ theme }) => theme.utils.pxToRem(17)}rem;
  margin-bottom: ${({ theme }) => theme.utils.pxToRem(-6)}rem;
  ${({ theme }) => theme.mixins.font('book', 12)}
  line-height: 1.17;
  color: ${({ theme }) => theme.colors.viewer.sidebar.gray};
`;
